export const Target = (props) => {
  return (
    <svg
      width={props.size || 24}
      height={props.size || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12.0005"
        cy="11.9946"
        r="3.09615"
        stroke={props.color || 'currentColor'}
        stroke-width="1.5"
      />
      <circle
        cx="12.0002"
        cy="12.0051"
        r="6.17308"
        stroke={props.color || 'currentColor'}
        stroke-width="1.5"
      />
      <circle
        cx="12"
        cy="12"
        r="9.25"
        stroke={props.color || 'currentColor'}
        stroke-width="1.5"
      />
    </svg>
  );
};
